import { NAME } from './constants.js';
import type { ConfirmSlice } from './reducer.js';

export const getDomainState = (state: ConfirmSlice) => state[NAME];
